
const isDevMode = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? true : false;
const apiUrl = isDevMode ? "https://localhost:7053/" : "https://wildfire.beacons-npa.gov.uk/";
const osapikey = "";

// 51.8700, -3.4500
const mapcenter = {
    lat: 51.87,
    lng: -3.45,
};
const gisserver = isDevMode ? "http://172.16.6.180:8080/" : "https://gis.beacons-npa.gov.uk/";
const maplayers = [
    {
        name: "Deep Peat",
        url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app:deep_peat&outputFormat=json&srsName=EPSG:4326",
        style: {
            fillColor: "black",
            color: "black"
        }
    },
    {
        name: "Fire Load",
        url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app:fire_load&outputFormat=json&srsName=EPSG:4326",
        style: {
            fillColor: "orange",
            color: "orange"
        }
    },
    {
        name: "Land Ownership",
        url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app:landownership&outputFormat=json&srsName=EPSG:4326",
        style: {
            fillColor: "brown",
            color: "brown"
        }
    },
    {
        name: "Linear Firebreaks",
        url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app:linear_firebreaks&outputFormat=json&srsName=EPSG:4326",
        style: {
            weight: 7
        }
    },
    {
        name: "Polygon Firebreaks",
        url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app:polygon_firebreaks&outputFormat=json&srsName=EPSG:4326",
        style: {}
    },
    {
        name: "Off Road Access Routes",
        url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app:off_road_access_routs&outputFormat=json&srsName=EPSG:4326",
        style: {
            fillColor: "red",
            color: "red",
            weight: 6
        }
    },
    {
        name: "Forest Roads",
        url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app:forest_roads&outputFormat=json&srsName=EPSG:4326",
        style: {
            fillColor: "#757575",
            color: "#757575",
            weight: 6
        }
    },
    {
        name: "Protected Areas",
        url: gisserver + "geoserver/planning_constraints/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=planning_constraints:SSSI_region&maxFeatures=5000&outputFormat=json&json&srsName=EPSG:4326",
        //  url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app:protected_areas&outputFormat=json&srsName=EPSG:4326",
        style: {
            fillColor: "red",
            color: "red"
        }
    },
    //{
    //    name: "Roads",
    //    url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app:roads&outputFormat=json&srsName=EPSG:4326",
    //    style: {}
    //},
    {
        name: "Water Sources",
        url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app:water_source&outputFormat=json&srsName=EPSG:4326",
        style: {}
    },
    {
        name: "Warden Areas",
        url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app%3Awardens_areas&maxFeatures=5000&outputFormat=application%2Fjson&srsName=EPSG:4326",
        style: {
            fillColor: "darkgreen",
            color: "darkgreen"
        }
    },
    /* invalid feature names
    wardenAreas: "https://gis.beacons-npa.gov.uk/geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app%3Awardens_areas&maxFeatures=5000&outputFormat=application%2Fjson&srsName=EPSG:4326",

    */
    {
        name: "Wildfires 24-25",
        url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app:burns_2024_25&maxFeatures=5000&outputFormat=application/json&srsName=EPSG:4326",
        style: {
            fillColor: "#FF0000",
            color: "#FF0000",
            fillOpacity: 0.6,
            weight: 1
        }
    },
    {
        name: "Wildfires 23-24",
        url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app:burns_2023_24&maxFeatures=5000&outputFormat=application/json&srsName=EPSG:4326",
        style: {
            fillColor: "#FFA500",
            color: "#FFA500",
            fillOpacity: 0.6,
            weight: 1
        }
    },
    {
        name: "Wildfires 22-23",
        url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app:burns_2022_23&maxFeatures=5000&outputFormat=application/json&srsName=EPSG:4326",
        style: {
            fillColor: "#008000",
            color: "#008000",
            fillOpacity: 0.6,
            weight: 1
        }
    },
    {
        name: "Wildfires 21-22",
        url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app:burns_2021_22&maxFeatures=5000&outputFormat=application/json&srsName=EPSG:4326",
        style: {
            fillColor: "#0000FF",
            color: "#0000FF",
            fillOpacity: 0.6,
            weight: 1
        }
    },
    {
        name: "Wildfires 20-21",
        url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app:burns_2020_21&maxFeatures=5000&outputFormat=application/json&srsName=EPSG:4326",
        style: {
            fillColor: "#800080",
            color: "#800080",
            fillOpacity: 0.6,
            weight: 1
        }
    },
    {
        name: "Coal",
        url: gisserver + "geoserver/wildfire_field_response_app/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=wildfire_field_response_app:Coal&maxFeatures=5000&outputFormat=application/json&srsName=EPSG:4326",
        style: {
            fillColor: "#000000",
            color: "#000000",
            fillOpacity: 0.6,
            weight: 1
        }
    },
]
const appconfig = {
    isdevmode: isDevMode,
    apiurl: apiUrl,
    osapikey: osapikey,
    center: mapcenter,
    maplayers: maplayers,
};

export default appconfig;